export default __webpack_public_path__ + "img/cogPZSOT.661b84ec.svg";